import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const component = universal(props => import('./GroupInvitesPage'))

class AsyncGroupInvitesPage extends AsyncPage {
  constructor() {
    super({
      pageComponent: component
    })
  }

}

export default new AsyncGroupInvitesPage()
